package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware

enum class PaymentTerminalEnum(val id: Int, val title: String) {
    HS_PAY_CLOUD(id = 14, title = "HS Pay - Cloud"),
    HS_PAY_TAP_TO_PAY(id = 15, title = "HS Pay - Tap to Pay"),
    WORLDLINE_TAP_ON_MOBILE(id = 11, title = "Worldline Tap On Mobile"),
    WALLEE_CLOUD_API(id = 10, title = "Wallee Cloud API"),
    NEXI_ATTENDED(id = 8, title = "Nexi attended"),
    WORLDLINE_TIM(id = 3, title = "Worldline TIM")
}